import React, { useState, useEffect } from 'react';
import { Clock, AlertCircle, Zap } from 'lucide-react';

const UrgencyBanner = () => {
  const [timeLeft, setTimeLeft] = useState({
    hours: 23,
    minutes: 45,
    seconds: 30
  });

  const [viewersCount, setViewersCount] = useState(12);

  useEffect(() => {
    // Countdown timer
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        let { hours, minutes, seconds } = prev;
        
        if (seconds > 0) {
          seconds--;
        } else if (minutes > 0) {
          minutes--;
          seconds = 59;
        } else if (hours > 0) {
          hours--;
          minutes = 59;
          seconds = 59;
        } else {
          // Reset to 24 hours when reaches 0
          hours = 23;
          minutes = 59;
          seconds = 59;
        }
        
        return { hours, minutes, seconds };
      });
    }, 1000);

    // Random viewer count fluctuation
    const viewersInterval = setInterval(() => {
      setViewersCount(prev => {
        const change = Math.random() > 0.5 ? 1 : -1;
        const newCount = prev + change;
        return Math.max(8, Math.min(25, newCount)); // Keep between 8-25
      });
    }, 8000);

    return () => {
      clearInterval(timer);
      clearInterval(viewersInterval);
    };
  }, []);

  return (
    <>
      {/* Top Urgency Banner */}
      <div className="bg-gradient-to-r from-orange-500 to-red-500 text-white py-2.5 px-4 sticky top-0 z-40 shadow-md">
        <div className="max-w-7xl mx-auto flex items-center justify-center gap-6 flex-wrap text-sm">
          {/* Limited Slots */}
          <div className="flex items-center gap-2">
            <AlertCircle size={18} className="animate-pulse" />
            <span className="font-semibold">Only 3 consultation slots left this week!</span>
          </div>

          {/* Countdown Timer */}
          <div className="flex items-center gap-2">
            <Clock size={18} />
            <span>Free consultation offer ends in:</span>
            <div className="flex gap-1 font-mono font-bold">
              <span className="bg-white text-orange-600 px-2 py-0.5 rounded">
                {String(timeLeft.hours).padStart(2, '0')}
              </span>
              <span>:</span>
              <span className="bg-white text-orange-600 px-2 py-0.5 rounded">
                {String(timeLeft.minutes).padStart(2, '0')}
              </span>
              <span>:</span>
              <span className="bg-white text-orange-600 px-2 py-0.5 rounded">
                {String(timeLeft.seconds).padStart(2, '0')}
              </span>
            </div>
          </div>

          {/* Live viewers */}
          <div className="flex items-center gap-2">
            <div className="flex">
              <span className="relative flex h-2.5 w-2.5">
                <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-green-400 opacity-75"></span>
                <span className="relative inline-flex rounded-full h-2.5 w-2.5 bg-green-500"></span>
              </span>
            </div>
            <span>{viewersCount} people viewing this page now</span>
          </div>
        </div>
      </div>

      {/* Floating Urgency Badge (Mobile) */}
      <div className="fixed bottom-20 right-4 z-40 md:hidden">
        <div className="bg-red-500 text-white px-4 py-2 rounded-full shadow-lg flex items-center gap-2 animate-bounce">
          <Zap size={16} fill="white" />
          <span className="text-xs font-bold">3 slots left!</span>
        </div>
      </div>
    </>
  );
};

export default UrgencyBanner;
